import { environment } from '../../../environments/environment';
import { ɵElement, ɵValue } from '@angular/forms';
import moment from 'moment/moment';

export function calculDiffDays(startDate: string, endDate: string): number {
  
  let date1 = new Date(startDate ? startDate : new Date());
  let date2 = new Date(endDate ? endDate : new Date());

  // Calculating the time difference
  // of two dates
  let Difference_In_Time = date2.getTime() - date1.getTime();

  // Calculating the no. of days between
  // two dates
  let Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));

  // To display the final no. of days (result)
  return Difference_In_Days + 1;
}
export function calculDiffDays2(startDate: string, endDate: string): number {
  let date1 = new Date(startDate ? startDate : new Date());
  let date2 = new Date(endDate ? endDate : new Date());

  // Calculating the time difference
  // of two dates
  let Difference_In_Time = date2.getTime() - date1.getTime();

  // Calculating the no. of days between
  // two dates
  let Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));

  // To display the final no. of days (result)
  return Difference_In_Days;
}

export function textSubstring(str: string, maxLength: number): string {
  return str?.length > maxLength ? str?.substring(0, maxLength) + '...' : str;
}

export function displayImg(img: string | null | undefined): string {
    if (!img) return '/assets/images/no-picture.jpg';

  if (img.startsWith('/api/')) {
    return environment.api.BASE_URL_NOTIF + img;
  }

  if (!!img && img.startsWith('data:')) {
    return img ;
  }
  
  return img ? environment.BASE_64 + img : 'assets/icons/no-pic.svg';
}
export function convertToUTF8(
  text: ɵValue<ɵElement<(number | null)[], null>> | undefined
): number {
  // const text = 'Some text to convert';
  const encoder = new TextEncoder();
  const utf8Array = encoder.encode(text?.toString());
  // If you need it as a string again

  const decoder = new TextDecoder('utf-8');
  const decodedString = decoder.decode(utf8Array);
  return parseInt(decodedString, 10);
}

export function filterArrayByField(
  value: string,
  array: any[],
  field: string
): any[] {
  const lowerCaseValue = value?.toLowerCase();

  return array.filter((item) => {
    let fieldValue = item?.[field]?.toLowerCase();

    if (!fieldValue) {
      return false;
    }

    // Check if fieldValue starts with the lowerCaseValue
    for (let i = 0; i < lowerCaseValue.length; i++) {
      if (fieldValue.charAt(i) !== lowerCaseValue.charAt(i)) {
        return false;
      }
    }
    return true;
  });
}
export function calculateDaysWithTime(startDate: string, endDate: string, startTime: string, endTime: string): number {
  const msInHour = 1000 * 60 * 60;
  const msInDay = msInHour * 24;

  // Combine startDate and startTime
  const startDateTime = new Date(`${startDate}T${startTime}`);

  // Combine endDate and endTime
  const endDateTime = new Date(`${endDate}T${endTime}`);

  // Calculate the difference in milliseconds
  const timeDifference = endDateTime.getTime() - startDateTime.getTime();

  // Calculate total full days (rounding down)
  const fullDays = Math.floor(timeDifference / msInDay);

  // Calculate remaining hours
  const remainingHours = (timeDifference % msInDay) / msInHour;

  // Apply the rule: if there's any remaining hour, we add an extra day
  return remainingHours > 0 ? fullDays + 1 : fullDays;
}
export function removeBlankAttributes(obj: any) {
  const result: any = {};
  for (const key in obj) {
    if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
      result[key] = obj[key];
    }
  }
  return result;
}

export function isMissionExpired(endDate: string, endTime: string): boolean {
  // Golden rule: a mission is "terminée" (expired) when NOW is strictly after its
  // end date + end time. No end date → never expired; no end time → end of that day.
  if (!endDate) {
    return false;
  }
  const end = endTime
    ? moment(moment(endDate).format('YYYY-MM-DD') + ' ' + endTime, 'YYYY-MM-DD HH:mm:ss')
    : moment(endDate).endOf('day');
  return moment().isAfter(end);
}

export var Base64 = {
  _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
  encode: function (e: any) {
    var t = '';
    var n, r, i, s, o, u, a;
    var f = 0;
    e = Base64._utf8_encode(e);
    while (f < e.length) {
      n = e.charCodeAt(f++);
      r = e.charCodeAt(f++);
      i = e.charCodeAt(f++);
      s = n >> 2;
      o = ((n & 3) << 4) | (r >> 4);
      u = ((r & 15) << 2) | (i >> 6);
      a = i & 63;
      if (isNaN(r)) {
        u = a = 64;
      } else if (isNaN(i)) {
        a = 64;
      }
      t =
        t +
        this._keyStr.charAt(s) +
        this._keyStr.charAt(o) +
        this._keyStr.charAt(u) +
        this._keyStr.charAt(a);
    }
    return t;
  },
  decode: function (e: any) {
    var t = '';
    var n, r, i;
    var s, o, u, a;
    var f = 0;
    e = e.replace(/[^A-Za-z0-9\+\/\=]/g, '');
    while (f < e.length) {
      s = this._keyStr.indexOf(e.charAt(f++));
      o = this._keyStr.indexOf(e.charAt(f++));
      u = this._keyStr.indexOf(e.charAt(f++));
      a = this._keyStr.indexOf(e.charAt(f++));
      n = (s << 2) | (o >> 4);
      r = ((o & 15) << 4) | (u >> 2);
      i = ((u & 3) << 6) | a;
      t = t + String.fromCharCode(n);
      if (u != 64) {
        t = t + String.fromCharCode(r);
      }
      if (a != 64) {
        t = t + String.fromCharCode(i);
      }
    }
    t = Base64._utf8_decode(t);
    return t;
  },
  _utf8_encode: function (e: any) {
    e = e.replace(/\r\n/g, '\n');
    var t = '';
    for (var n = 0; n < e.length; n++) {
      var r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
      } else if (r > 127 && r < 2048) {
        t += String.fromCharCode((r >> 6) | 192);
        t += String.fromCharCode((r & 63) | 128);
      } else {
        t += String.fromCharCode((r >> 12) | 224);
        t += String.fromCharCode(((r >> 6) & 63) | 128);
        t += String.fromCharCode((r & 63) | 128);
      }
    }
    return t;
  },
  _utf8_decode: function (e: any) {
    var t = '';
    var n = 0;
    var c1;
    var c2;
    var c3;
    var r = (c1 = c2 = 0);
    while (n < e.length) {
      r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
        n++;
      } else if (r > 191 && r < 224) {
        c2 = e.charCodeAt(n + 1);
        t += String.fromCharCode(((r & 31) << 6) | (c2 & 63));
        n += 2;
      } else {
        c2 = e.charCodeAt(n + 1);
        c3 = e.charCodeAt(n + 2);
        t += String.fromCharCode(
          ((r & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
        );
        n += 3;
      }
    }
    return t;
  },
};
